import { storage } from '@/services/storage'

import { helpersMixin } from '@/mixins'

export default {
	mixins: [ helpersMixin ],
	data() {
		return {
			visibleColumns: this.columns.map((x) => {
				return this.snakeCase(x.title)
			}),
			columnsStorage: {}
		}
	},
	computed: {
		loadComponent() {
			return () => import('@/components/ui-facilita/' + this.trComponent)
		},
		columnsComputed() {
			return this.columns.filter((column) => column.title)
		},
		/** Nome usado no local-storage para salvar os filtros de colunas visiveis */
		// storageColumnsName() {
		// 	return 'table_storage_columns_' + this.snakeCase(this.name || '')
		// },
	},
	methods: {
		/**
		 * @param Object evento do click
		 * @param Number index da coluna da tabela
		 * Esconde ou mostra uma coluna especifica da tabela a partir do index
		 * Mostrar e esconder é feito apenas via CSS. Não é alterado o array da tabela.
		 */
		toggleColumn(index, add) {
			let theadColumns
			let tBodyId 
			let tbodyTRs

			theadColumns = this.$refs['thead'] && this.$refs['thead'].firstChild && this.$refs['thead'].firstChild.cells ? this.$refs['thead'].firstChild.cells : null
			
			// o dragable não esta funcionando com refs é preciso passar o id no casos da dragable
			tBodyId = document.getElementById('tbody') && document.getElementById('tbody').children ? document.getElementById('tbody').children : null

			if (tBodyId) tbodyTRs = tBodyId
			else tbodyTRs = this.$refs['tbody'] && this.$refs['tbody'].children ? this.$refs['tbody'].children : null

			if (!theadColumns || !tbodyTRs) return

			const htmlCollection = Array.from(theadColumns)
			const item = htmlCollection.findIndex((column) => column.getAttribute('data-index') == index)

			if (item == -1) return

			if (add) {
				theadColumns[item].classList.add('hidden')
				for (const tr of tbodyTRs) {
					tr.children[item].classList.add('hidden') 
				}
			} else {
				theadColumns[item].classList.toggle('hidden')
				for (const tr of tbodyTRs) {
					tr.children[item].classList.toggle('hidden')
				}
			}
		},
		/**
		 * Array com as colunas visiveis, usado como cópia do local-storage
		 * Verifica se tem já existe
		 * se existe remove do array e do local storage
		 * se não existe adiciona no array e no local storage
		 */
		toggleColumnsArray(index) {
			this.visibleColumns = this.visibleColumns.includes(index)
				? this.visibleColumns.filter((i) => i !== index)
				: [...this.visibleColumns, index]
			this.visibleColumns = this.visibleColumns.sort(function (a, b) {
				return a - b
			})
			this.toggleColumnStorage()
		},
		/**
		 * Salva as colunas visiveis no local-storage
		 * É um array com o $index da coluna que deve estar visível
		 */
		toggleColumnStorage() {
			this.$nextTick(() => {
				this.columnsStorage[this.snakeCase(this.name)] = [...this.visibleColumns]
				storage.set('table_storage_columns', JSON.stringify(this.columnsStorage))
			})
		},
		/**
		 * Define a classe do item/botão no menu de de seleção de colunas
		 */
		setActiveClass(index) {
			return this.visibleColumns.includes(index) ? 'active' : ''
		},
		/**
		 * @param Number index do TR/linha da tabela
		 * Para esconder uma coluna é preciso que a tabela já esteja montada na tela e
		 * para saber se ja foi montado é comparado on index do evento com a quantidade
		 * de linhas de cada tela.
		 * Faz uma inversão no array e esconde os itens salvos no local-storage.
		 */
		prepareTable(index) {
			if(!index) this.isloading = false

			let data = this.data ? this.data : this.datatable.data

			// Verifica se é a ultima TR/Linha
			if((data.length - 1) === index) {
				this.$nextTick(() => {
					let arr = this.columns.map((x) => { return this.snakeCase(x.title) })
					arr = arr.filter(item => !this.visibleColumns.includes(item))

					for (const column of arr) {
						this.toggleColumn(column, true)
					}

					this.isloading = false
				})
			}
		},
		/**
		 * Limita a quantidade minima de colunas para 1
		 * Verifica a quantidade minima e se já existe
		 */
		setColumn(index) {
			if (this.visibleColumns.length < 3 && this.visibleColumns.includes(index)) return null

			this.toggleColumn(index)
			this.toggleColumnsArray(index)
		},
		/**
		 * 
		 */
		getColumns() {
			if (this.selectColumnMenu) {

				this.columnsStorage = JSON.parse(storage.get('table_storage_columns')) 
				? JSON.parse(storage.get('table_storage_columns')) : {}

				this.visibleColumns = this.columnsStorage[this.snakeCase(this.name)] ? 
				this.columnsStorage[this.snakeCase(this.name)] : this.visibleColumns

				this.toggleColumnStorage()
				this.isloading = true
			}
		}
	},
}
